// src/api/cart.api.ts
import { get, post, put, del } from './client';
import { ApiResponse, Cart, CartItem, AddToCartDto, UpdateCartItemDto } from '../types';

// Helper to get/set session ID
const getSessionId = (): string | null => {
  return localStorage.getItem('cartSessionId');
};

const setSessionId = (sessionId: string): void => {
  localStorage.setItem('cartSessionId', sessionId);
};

// Add session header to requests
const getSessionHeader = () => {
  const sessionId = getSessionId();
  return sessionId ? { 'x-session-id': sessionId } : {};
};

export const cartApi = {
  // إضافة عنصر للسلة
  addToCart: async (data: AddToCartDto) => {
    const response = await post<ApiResponse<{ cartItem: CartItem; sessionId: string }>>(
      '/cart',
      data,
      { headers: getSessionHeader() }
    );
    
    // Save session ID if returned
    if (response.data.data.sessionId) {
      setSessionId(response.data.data.sessionId);
    }
    
    return response;
  },

  // الحصول على السلة
  getCart: () => {
    return get<ApiResponse<Cart>>('/cart', { headers: getSessionHeader() });
  },

  // تحديث عنصر في السلة
  updateCartItem: (id: string, data: UpdateCartItemDto) => {
    return put<ApiResponse<CartItem>>(`/cart/${id}`, data, { headers: getSessionHeader() });
  },

  // حذف عنصر من السلة
  removeFromCart: (id: string) => {
    return del<ApiResponse>(`/cart/${id}`, { headers: getSessionHeader() });
  },

  // تفريغ السلة
  clearCart: () => {
    return del<ApiResponse>('/cart', { headers: getSessionHeader() });
  },

  // التحقق من السلة
  validateCart: () => {
    return get<ApiResponse<{ isValid: boolean; restaurantId: string; items: CartItem[] }>>(
      '/cart/validate',
      { headers: getSessionHeader() }
    );
  },

  // Get session ID
  getSessionId,
  setSessionId,
};